import React from 'react'
import SubHeader from '../../layout/components/SubHeader'
import { useNavigate } from 'react-router-dom'
function NewsletterHeader() {
    const navigate = useNavigate()
    const handleCreateNewCampaign = () => {
        navigate('/newsletter/create-email')
    }
  return (
    <>
        <SubHeader title="Email Newsletter" description={"Email Newsletter Communication"} >
            <div className="d-flex justify-content-end">
                <button className="btn btn-light-primary btn-sm" onClick={handleCreateNewCampaign}>Create New Campaign</button>
            </div>
        </SubHeader>
    </>
  )
}

export default NewsletterHeader
